import { HugeiconsIcon } from "@hugeicons/react";
import {
  ArrowLeft01Icon,
  ArrowRight01Icon,
} from "@hugeicons-pro/core-stroke-rounded";

export function ChevronRightIcon({ className }: { className?: string }) {
  return <HugeiconsIcon icon={ArrowRight01Icon} className={className} />;
}

export function ChevronLeftIcon({ className }: { className?: string }) {
  return <HugeiconsIcon icon={ArrowLeft01Icon} className={className} />;
}
